import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import portugues from "ra-language-pt-br";

/** Textos do ra-supabase em português (o pacote só traz inglês e francês). */
const raSupabasePortugues = {
  "ra-supabase": {
    auth: {
      email: "E-mail",
      confirm_password: "Confirme a senha",
      sign_in_with: "Entrar com %{provider}",
      forgot_password: "Esqueceu a senha?",
      reset_password: "Redefinir senha",
      password_reset: "Senha redefinida. Você vai receber um e-mail com o link de acesso.",
      missing_tokens: "O link de acesso está incompleto ou expirou. Peça um novo.",
      back_to_login: "Voltar para o login",
    },
    reset_password: {
      forgot_password: "Esqueceu a senha?",
      forgot_password_details: "Informe seu e-mail para receber as instruções.",
    },
    set_password: {
      new_password: "Escolha sua senha",
    },
    validation: {
      password_mismatch: "As senhas não conferem",
    },
  },
};

/** Nomes das telas e campos. */
const sistema = {
  resources: {
    licitacao: {
      name: "Licitação |||| Licitações",
      fields: {
        pessoa_id: "Órgão",
        unidade_compradora_id: "Unidade compradora",
        portal_id: "Portal",
        numero_controle_pncp: "Número de controle PNCP",
        numero: "Número",
        processo: "Processo",
        modalidade_id: "Modalidade",
        srp: "Registro de preços (SRP)",
        objeto: "Objeto",
        uf_destino: "UF de destino",
        inicio_recebimento_propostas: "Início do recebimento de propostas",
        fim_recebimento_propostas: "Fim do recebimento de propostas",
        data_hora_sessao: "Data e hora da sessão",
        prazo_impugnacao: "Prazo para impugnação",
        prazo_esclarecimento: "Prazo para esclarecimento",
        vigencia_ata_meses: "Vigência da ata (meses)",
        prazo_entrega_dias: "Prazo de entrega (dias)",
        prazo_pagamento_dias: "Prazo de pagamento (dias)",
        carona_limite_aderente_pct: "Carona por aderente (%)",
        carona_limite_total_pct: "Carona total (%)",
        margem_preferencia: "Edital com margem de preferência",
        status: "Status",
        responsavel_id: "Responsável",
        pasta_url: "Link da pasta",
        observacao: "Observação",
      },
    },
    v_licitacao: {
      name: "Licitação |||| Licitações",
      fields: {
        orgao_nome: "Órgão",
        numero: "Número",
        modalidade_nome: "Modalidade",
        objeto: "Objeto",
        data_hora_sessao: "Sessão",
        status: "Status",
        itens: "Itens",
        valor_estimado_total: "Valor estimado",
        valor_proposto_total: "Valor proposto",
        pessoa_id: "Órgão",
        portal_id: "Portal",
        responsavel_id: "Responsável",
      },
    },
    pessoa: {
      name: "Órgão ou cliente |||| Órgãos e clientes",
      fields: {
        tipo: "Tipo",
        documento: "CNPJ ou CPF",
        nome: "Nome",
        sigla: "Sigla",
        razao_social: "Razão social",
        inscricao_estadual: "Inscrição estadual",
        esfera: "Esfera",
        natureza_juridica: "Natureza jurídica",
        logradouro: "Endereço",
        numero: "Número",
        complemento: "Complemento",
        bairro: "Bairro",
        municipio: "Município",
        uf: "UF",
        cep: "CEP",
        email: "E-mail",
        telefone: "Telefone",
        site: "Site",
        observacao: "Observação",
        ativo: "Ativo",
      },
    },
    atestado_capacidade: {
      name: "Atestado |||| Atestados",
      fields: {
        pessoa_id: "Órgão emissor",
        objeto: "Objeto",
        situacao: "Situação",
        data_solicitacao: "Solicitado em",
        data_emissao: "Emitido em",
        referencia: "Referência",
        observacao: "Observação",
      },
    },
    transportadora: {
      name: "Transportadora |||| Transportadoras",
      fields: {
        nome: "Nome",
        razao_social: "Razão social",
        cnpj: "CNPJ",
        contato: "Contato",
        telefone: "Telefone",
        whatsapp: "WhatsApp",
        email: "E-mail",
        site: "Site",
        url_rastreio: "Endereço de rastreio",
        observacao: "Observação",
        ativo: "Ativa",
      },
    },
    produto: {
      name: "Produto |||| Produtos",
      fields: {
        codigo: "Código",
        descricao: "Descrição",
        fabricante: "Fabricante",
        fabricante_id: "Fabricante",
        modelo: "Modelo",
        grupo_id: "Grupo",
        informatica: "Informática (fiscal)",
        ncm: "NCM",
        unidade_base: "Unidade-base",
        url: "Página do produto",
        observacao: "Observação",
        ativo: "Ativo",
      },
    },
    fornecedor: {
      name: "Fornecedor |||| Fornecedores",
      fields: {
        nome: "Nome",
        razao_social: "Razão social",
        cnpj: "CNPJ",
        uf: "UF de origem",
        setor_id: "Setor",
        vendedor: "Vendedor",
        telefone: "Telefone",
        whatsapp: "WhatsApp",
        email: "E-mail",
        url: "Site",
        observacao: "Observação",
        ativo: "Ativo",
      },
    },
    fabricante: {
      name: "Fabricante |||| Fabricantes",
      fields: { nome: "Nome", ativo: "Ativo" },
    },
    unidade_medida: {
      name: "Unidade de medida |||| Unidades de medida",
      fields: { sigla: "Sigla", descricao: "Descrição", ativo: "Ativa" },
    },
    setor_fornecedor: {
      name: "Setor de fornecedor |||| Setores de fornecedor",
      fields: { nome: "Nome", ativo: "Ativo" },
    },
    grupo_produto: {
      name: "Grupo de produto |||| Grupos de produto",
      fields: { nome: "Nome", ativo: "Ativo" },
    },
    parametro_sistema: {
      name: "Parâmetro do sistema |||| Parâmetros do sistema",
      fields: { chave: "Parâmetro", valor: "Valor", vigente_desde: "Vigente desde", origem: "Origem / justificativa" },
    },
    empresa: {
      name: "Dados da empresa |||| Dados da empresa",
      fields: {
        razao_social: "Razão social",
        marca: "Marca / nome fantasia",
        cnpj: "CNPJ",
        inscricao_estadual: "Inscrição estadual",
        nire: "NIRE",
        logradouro: "Logradouro",
        numero: "Número",
        complemento: "Complemento",
        bairro: "Bairro",
        municipio: "Município",
        uf: "UF",
        cep: "CEP",
        telefone: "Telefone",
        email: "E-mail",
        site: "Site",
        representante_nome: "Nome do representante",
        representante_cpf: "CPF do representante",
        representante_cargo: "Cargo",
        banco: "Banco",
        agencia: "Agência",
        conta: "Conta",
        pix: "Chave PIX",
      },
    },
    portal: {
      name: "Portal |||| Portais",
      fields: {
        nome: "Nome",
        url: "Endereço (URL)",
        ativo: "Ativo",
      },
    },
    conta_portal: {
      name: "Conta em portal |||| Contas em portais",
      fields: {
        portal_id: "Portal",
        usuario_login: "Login",
        plano: "Plano",
        vencimento_assinatura: "Vencimento da assinatura",
        responsavel_id: "Responsável",
        ativo: "Ativa",
      },
    },
    usuario: {
      name: "Usuário |||| Usuários",
      fields: {
        nome: "Nome",
        email: "E-mail",
        papel_id: "Papel",
        ativo: "Ativo",
        elegivel_comissao: "Elegível a comissão",
        criado_em: "Criado em",
      },
    },
    parametro_preco_padrao: {
      name: "Padrão de preço |||| Padrões de preço",
      fields: {
        vigente_desde: "Vigente desde",
        margem: "Margem",
        seguro: "Seguro",
        custo_fixo: "Custo fixo",
        simples: "Simples",
        frete_cif_pct: "Frete CIF",
        origem: "Origem / justificativa",
        criado_em: "Cadastrado em",
      },
    },
    v_aliquota_icms_vigente: {
      name: "Alíquota de ICMS |||| Matriz de ICMS",
      fields: {
        uf_origem: "Origem",
        uf_destino: "Destino",
        aliquota: "Alíquota",
        vigente_desde: "Vigente desde",
        origem: "Fonte",
      },
    },
    parametro_fiscal: {
      name: "Parâmetro fiscal |||| Parâmetros fiscais",
      fields: {
        chave: "Parâmetro",
        uf: "UF",
        valor: "Valor",
        vigente_desde: "Vigente desde",
        fonte: "Fonte legal",
      },
    },
    regra_preco: {
      name: "Regra de preço |||| Regras de preço",
      fields: {
        regra: "Regra",
        vigente_desde: "Vigente desde",
        justificativa: "Justificativa",
      },
    },
    auditoria: {
      name: "Registro |||| Auditoria",
      fields: {
        data: "Data",
        tabela: "Tabela",
        operacao: "Operação",
        campo: "Campo",
        valor_antigo: "Antes",
        valor_novo: "Depois",
        usuario_id: "Usuário",
        registro_id: "Registro",
      },
    },
  },
};

const mensagens = mergeTranslations(portugues, raSupabasePortugues, sistema);

export const i18nProvider = polyglotI18nProvider(() => mensagens, "pt-br", [{ locale: "pt-br", name: "Português" }], {
  allowMissing: true,
});
